export default __webpack_public_path__ + "static/media/8.f80999a1.svg";